import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  icon: '🔎',
  title: 'ESCÁNER EXPRESS',
  subtitle: '15 Tarjetas de Lectura Rápida',
  value: '$4.999'
}, {
  icon: '😶',
  title: 'MICROEXPRESIONES EN VIVO',
  subtitle: '15 Tarjetas para Detectar Mentiras',
  value: '$4.999'
}, {
  icon: '🚦',
  title: 'SEMÁFORO DEL DESEO',
  subtitle: '15 Tarjetas de Atracción vs Cortesía',
  value: '$4.999'
}, {
  icon: '🤫',
  title: 'INTERROGATORIO SUAVE',
  subtitle: '15 Tarjetas para Sacar Verdad',
  value: '$4.999'
}, {
  icon: '🛡️',
  title: 'ANTI MANIPULACIÓN',
  subtitle: '15 Tarjetas de Banderas Rojas',
  value: '$4.999'
}, {
  icon: '👑',
  title: 'PRESENCIA Y CARISMA',
  subtitle: '15 Tarjetas de Autoridad Real',
  value: '$4.999'
}];
export function BonusSection() {
  return <section className="pt-6 pb-14 px-4 bg-deep-black relative" data-id="element-17">
      <div className="max-w-4xl mx-auto" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-19">
          <div className="inline-block bg-gold/10 border border-gold text-gold px-5 py-1.5 rounded-full font-bold text-xs tracking-widest mb-4 animate-pulse" data-id="element-20">
            🎁 GRATIS SOLO POR HOY
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-21">
            Además del Pack, recibís 6 Bonus Gratis
          </h2>
          <p className="text-lg text-smoke/80" data-id="element-22">
            Valor total: $29.994 — Para vos: $0
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-8" data-id="element-23">
          {bonuses.map((bonus, index) => <div key={index} className={`animate-fade-in-up stagger-${index + 1} bg-[#111] border border-gold/20 p-4 rounded-xl relative overflow-hidden group hover:border-gold/50 transition-colors`} data-id="element-24">
              <div className="flex items-center gap-2.5 mb-2" data-id="element-25">
                <span className="text-2xl" data-id="element-26">{bonus.icon}</span>
                <h3 className="font-heading font-bold text-sm text-white leading-tight" data-id="element-27">
                  {bonus.title}
                </h3>
              </div>
              <p className="text-gold text-xs font-medium mb-2 leading-snug" data-id="element-28">
                {bonus.subtitle}
              </p>
              <div className="flex items-center gap-2" data-id="element-29">
                <span className="text-smoke/40 line-through text-xs" data-id="element-30">
                  {bonus.value}
                </span>
                <span className="bg-electric-blue text-white text-[10px] font-bold px-1.5 py-0.5 rounded" data-id="element-31">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}